module.exports = __webpack_public_path__ + "_/_/_/node_modules/@reverbdotcom/discovery-ui/images/app-store-badges/google-play-store-fr-d60ff9f626eb1e17a33f4946eee0922c.svg";


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/images/app-store-badges/google-play-store-fr.svg
// module id = LwDf
// module chunks = 20 22